import React from 'react';
import { useTranslation } from 'react-i18next';
import TransactionsComponent from '@t7x000/apex-web/lib/components/Transactions/TransactionsComponent.js';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './TransactionsPage.css';

const baseClasses = getBEMClasses('transactions-page');

const TransactionsPage = () => {
  const { t } = useTranslation();

  return (
    <div className={baseClasses()}>
      <header className={baseClasses('header')}>
        <h1 className={baseClasses('title')}>{t('Transactions')}</h1>
      </header>
      <div className={baseClasses('content')}>
        <TransactionsComponent />
      </div>
    </div>
  );
};

export default TransactionsPage;
